import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';


export const LayoutHeaderFooterDefinition: IdtComponentDefinition = {
  id: 'layout-header-footer',
  role: IdtComponentRole.Layout,
  numSlots: 3,
  defaultSlot: 2
};

export const LayoutHeaderFooterCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Cabecera y pie',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web'],
  initialSettings: () => {
    return {
      general: {},
      styles: {},
      stickyFooter: false
    };
  }
};
